import { apiUrl } from '@algoan/dashboard/env';
import { Dispatch, AsyncThunk } from '@algoan/dashboard/store/store';
import { authRequest } from './auth-thunks';
import { Organization } from '@algoan/dashboard/model';
import {
  fetchOrganizationStart,
  fetchOrganizationSuccess,
  fetchOrganizationFailure,
} from '@algoan/dashboard/store/slice';

export const getOrganization =
  (organizationId: string): AsyncThunk<Organization | undefined> =>
  async (dispatch: Dispatch) => {
    try {
      const url = `${apiUrl}/v2/organizations/${organizationId}`;
      dispatch(fetchOrganizationStart());

      const { data: response } = await dispatch(authRequest<Organization>('get', url));
      dispatch(fetchOrganizationSuccess(response));

      return response;
    } catch (error) {
      dispatch(fetchOrganizationFailure({ error: 'genericError' }));
    }
    return undefined;
  };

export const createOrganization = (): AsyncThunk => async (dispatch: Dispatch) => {
  try {
    const url = `${apiUrl}/v2/organizations/signup`;

    await dispatch(authRequest('post', url, { createDefaultProject: true }));
    return;
  } catch (error) {
    return;
  }
};

export const patchOrganization =
  (organizationId: string | undefined, notifyUsersOnEveryAnalysisCreated: boolean): AsyncThunk<void> =>
  async (dispatch: Dispatch) => {
    const url = `${apiUrl}/v2/organizations/${organizationId}`;

    await dispatch(
      authRequest<Organization>('patch', url, {
        config: { notifyUsersOnEveryAnalysisCreated },
      }),
    );
  };
